export default __webpack_public_path__ + "static/media/joe neguse.ea1aab40.jpg";